import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=c69681ee&scoped=true&"
var script = {}
import style0 from "./PageTitle.vue?vue&type=style&index=0&id=c69681ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69681ee",
  null
  
)

export default component.exports